import { render } from "./BannerTable.vue?vue&type=template&id=af643a72"
import script from "./BannerTable.vue?vue&type=script&lang=js"
export * from "./BannerTable.vue?vue&type=script&lang=js"
script.render = render

export default script